export const i0Atacadista = ["333", "261", "235", "197", "171"];
export const i0Varejista = ["353", "281", "255", "217", "191"];
export const i5Atacadista = ["363", "291", "265", "227", "201"];
export const i5Varejista = ["383", "311", "285", "247", "221"];
export const i1Atacadista = ["523", "451", "425", "387", "361"];
export const i1Varejista = ["543", "471", "445", "407", "381"];

const norte = {
  i0Atacadista: ["269", "234", "222", "219", "172"],
  i0Varejista: ["279", "244", "232", "229", "182"],
  i5Atacadista: ["299", "264", "252", "249", "202"],
  i5Varejista: ["309", "274", "262", "259", "212"],
  i1Atacadista: ["429", "394", "382", "379", "332"],
  i1Varejista: ["439", "404", "392", "389", "342"],
};

const nordeste = {
  i0Atacadista: ["264", "234", "225", "223", "173"],
  i0Varejista: ["274", "244", "235", "233", "183"],
  i5Atacadista: ["294", "264", "255", "253", "203"],
  i5Varejista: ["304", "274", "265", "263", "213"],
  i1Atacadista: ["424", "394", "385", "383", "333"],
  i1Varejista: ["434", "404", "395", "393", "343"],
};

const sul = {
  i0Atacadista: ["335", "279", "263", "255", "205"],
  i0Varejista: ["345", "289", "273", "265", "215"],
  i5Atacadista: ["365", "309", "293", "285", "235"],
  i5Varejista: ["375", "319", "303", "295", "245"],
  i1Atacadista: ["495", "439", "423", "415", "365"],
  i1Varejista: ["505", "449", "433", "425", "375"],
};

const sudesteCentroOeste = {
  i0Atacadista: ["305", "269", "253", "245", "195"],
  i0Varejista: ["315", "279", "263", "255", "205"],
  i5Atacadista: ["335", "299", "283", "275", "225"],
  i5Varejista: ["345", "309", "293", "285", "235"],
  i1Atacadista: ["465", "429", "413", "405", "355"],
  i1Varejista: ["475", "439", "423", "415", "365"],
};

const prices = {
  norte,
  nordeste,
  sul,
  sudesteCentroOeste,
};

const submarketUF = {
  norte: ["AM", "PA", "AP", "MA", "TO", "RR"],
  nordeste: ["PI", "CE", "BA", "RN", "PB", "PE", "AL", "SE"],
  sul: ["PR", "SC", "RS"],
  sudesteCentroOeste: [
    "AC",
    "RO",
    "MT",
    "MS",
    "GO",
    "DF",
    "MG",
    "SP",
    "ES",
    "RJ",
  ],
};

const submarketApiMap = {
  NORTE: "norte",
  NORDESTE: "nordeste",
  SUL: "sul",
  SUDESTE: "sudesteCentroOeste",
};

const buildEmptyPriceStructure = () => ({});
// O formulário usa vírgula como separador decimal (pt-BR).
const toPriceString = (price) =>
  price == null ? "" : Number(price).toFixed(2).replace(".", ",");

export const getSubmarketByUF = (state) => {
  for (let key in submarketUF) {
    if (submarketUF[key].includes(state)) {
      return key;
    }
  }

  return null;
};

const normalizeSubmarket = (submarket) => {
  if (!submarket) return null;

  return submarketApiMap[String(submarket).toUpperCase()] || null;
};

export const transformEnergyPriceFromApi = (latestIndicativo = []) => {
  const transformed = {
    norte: buildEmptyPriceStructure(),
    nordeste: buildEmptyPriceStructure(),
    sul: buildEmptyPriceStructure(),
    sudesteCentroOeste: buildEmptyPriceStructure(),
  };

  const groupedBySubmarket = {
    norte: [],
    nordeste: [],
    sul: [],
    sudesteCentroOeste: [],
  };

  if (!Array.isArray(latestIndicativo)) return transformed;

  for (let i = 0; i < latestIndicativo.length; i++) {
    const item = latestIndicativo[i];
    const normalizedSubmarket = normalizeSubmarket(item?.submarket);

    if (!normalizedSubmarket) continue;

    groupedBySubmarket[normalizedSubmarket].push(item);
  }

  for (let key in groupedBySubmarket) {
    const ordered = groupedBySubmarket[key].sort(
      (a, b) => Number(a.year) - Number(b.year)
    );

    transformed[key] = ordered.reduce((pricesByYear, item) => {
      pricesByYear[Number(item.year)] = {
        i0Atacadista: toPriceString(item.wholesaleI0),
        i0Varejista: toPriceString(item.retailerI0),
        i5Atacadista: toPriceString(item.wholesaleI5),
        i5Varejista: toPriceString(item.retailerI5),
        i1Atacadista: toPriceString(item.wholesaleI1),
        i1Varejista: toPriceString(item.retailerI1),
      };

      return pricesByYear;
    }, {});
  }

  return transformed;
};

export const getPriceCurveForYear = (pricesByYear, year) => {
  if (!pricesByYear) return null;

  const latestAvailableYear = Object.keys(pricesByYear)
    .map(Number)
    .filter((availableYear) => availableYear <= year)
    .sort((a, b) => b - a)[0];

  return latestAvailableYear === undefined
    ? null
    : pricesByYear[latestAvailableYear];
};

export const getPriceCurvesForYears = (pricesByYear, years) =>
  years.map((year) => getPriceCurveForYear(pricesByYear, year));

export const getPriceBySubmarketFromMatrix = (state, matrix) => {
  const submarket = getSubmarketByUF(state);

  if (!submarket || !matrix?.[submarket]) return null;

  return matrix[submarket];
};

export const getPriceBySubmarket = (state) => {
  const submarket = getSubmarketByUF(state);

  if (!submarket) return null;

  return prices[submarket];
};
